module.exports = __webpack_public_path__ + "static/media/ASOS.59c86ba8.svg";